import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Tooltip = (props) => {
  const [isActive, setIsActive] = useState(false);
  const toolTipRef = useRef(null);

  const handleClickOutside = (event) => {
    if (toolTipRef.current && !toolTipRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleTrigger = () => {
    setIsActive(!isActive);
  };

  const { offset, className, children } = props;
  return (
    <div
      className={`${className} tooltip ${offset !== 0 ? `offset${offset}` : ''} ${isActive ? 'active' : ''}`}
      ref={toolTipRef}
    >
      <div
        className="trigger"
        onClick={handleTrigger}
      />
      <div
        className="card"
        onClick={handleTrigger}
      >
        <p className="tooltipContent">{children}</p>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  offset: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
  offset: 0,
  className: '',
};

export default Tooltip;
